// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"442":"a9701006","874":"00dc01a0"}[chunkId] + ".css";
};